/* eslint react/no-unused-prop-types: 'off' */
/* eslint jsx-a11y/interactive-supports-focus: 'off' */
/* eslint jsx-a11y/no-autofocus: 'off' */
import React, { forwardRef, useRef, useEffect } from 'react';
import { FormGroup, FormControl } from 'react-bootstrap';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';
import PropTypes from 'prop-types';

import List from './List';

import { useWindowSize } from '../../../../utils/hooks/useWindowSize';

const Menu = forwardRef(
  (
    {
      rootCloseEvent,
      open,
      setInputValue,
      filteredOptions,
      selected,
      inputValue,
      inputRef,
      listRefs,
      toggleText,
      focusedIndex,
      preselectFirst,
      showOptionId,
      listMaxHeight,
      handleFocus,
      onToggleClose,
      onSelectValue,
    },
    ref,
  ) => {
    const listRef = useRef(null);
    const windowSize = useWindowSize();

    const handleKeyDown = (e) => {
      if (e.keyCode === 40 || e.keyCode === 38) {
        e.preventDefault();
      }
    };

    useEffect(
      () => () => !selected
        && listRef?.current?.scrollTo({
          top: 0,
          left: 0,
        }),
      [open, listRef, selected],
    );

    return (
      <RootCloseWrapper disabled={!open} onRootClose={onToggleClose} event={rootCloseEvent}>
        <div
          style={{
            width: windowSize.width < 400 ? '300px' : windowSize.width < 768 ? `${windowSize.width - 50}px` : '',
            minWidth: windowSize.width < 400 ? '300px' : windowSize.width < 768 ? `${windowSize.width - 50}px` : '',
            maxHeight: `${windowSize.height - 150}px`,
          }}
          ref={ref}
          onClick={() => handleFocus()}
          role="listbox"
          className="dropdown-menu dropdown-menu__select"
        >
          <FormGroup className="dropdown-menu__input">
            <FormControl
              inputRef={inputRef}
              onChange={(e) => setInputValue(e.target.value)}
              onKeyDown={handleKeyDown}
              value={inputValue}
              autoComplete="false"
              type="text"
              autoFocus
            />
          </FormGroup>

          <List
            ref={listRef}
            listRefs={listRefs}
            filteredOptions={filteredOptions}
            inputValue={inputValue}
            selected={selected}
            toggleText={toggleText}
            preselectFirst={preselectFirst}
            focusedIndex={focusedIndex}
            showOptionId={showOptionId}
            listMaxHeight={listMaxHeight}
            onToggleClose={onToggleClose}
            onSelectValue={onSelectValue}
          />
        </div>
      </RootCloseWrapper>
    );
  },
);

Menu.propTypes = {
  ref: PropTypes.oneOf([PropTypes.func, PropTypes.shape({ current: PropTypes.instanceOf(Element) })]),
  inputRef: PropTypes.object,
  listRefs: PropTypes.object,
  rootCloseEvent: PropTypes.string,
  open: PropTypes.bool,
  setInputValue: PropTypes.func,
  inputValue: PropTypes.string,
  selected: PropTypes.object,
  toggleText: PropTypes.string,
  preselectFirst: PropTypes.bool,
  focusedIndex: PropTypes.number,
  showOptionId: PropTypes.bool,
  filteredOptions: PropTypes.array,
  listMaxHeight: PropTypes.number,
  handleFocus: PropTypes.func,
  onToggleClose: PropTypes.func,
  onSelectValue: PropTypes.func,
};

export default Menu;
